var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.pram.id ? "编辑商品标签" : "新增商品标签",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "100px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标签名称：",
                    prop: "labelName",
                    rules: _vm.labelNameRules,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      maxlength: "20",
                      "show-word-limit": "",
                      placeholder: "请输入",
                    },
                    on: { input: _vm.handleLabelNameValidate },
                    model: {
                      value: _vm.pram.labelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "labelName", $$v)
                      },
                      expression: "pram.labelName",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v("此标签名称只在后台展示，与移动端效果无关"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "商品来源：",
                    prop: "productSource",
                    rules: _vm.productSourceRules,
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.productSource,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "productSource", $$v)
                        },
                        expression: "pram.productSource",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("普通商品"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "背景图：",
                    prop: "backgroundImage",
                    rules: _vm.backgroundImageRules,
                  },
                },
                [
                  _vm.userType === 1
                    ? _c("div", { staticClass: "upload-row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "upLoadPicBox",
                            on: { click: _vm.modalPicTap },
                          },
                          [
                            _vm.pram.backgroundImage
                              ? _c("div", { staticClass: "pictrue" }, [
                                  _c("img", {
                                    attrs: { src: _vm.pram.backgroundImage },
                                  }),
                                ])
                              : _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.pram.backgroundImage
                          ? _c("i", {
                              staticClass: "el-icon-delete remove-icon",
                              on: { click: _vm.removeImg },
                            })
                          : _vm._e(),
                      ])
                    : _c(
                        "div",
                        { staticClass: "upload-row" },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "bg-uploader",
                              attrs: {
                                action: "",
                                "show-file-list": false,
                                "http-request": _vm.handleLocalUpload,
                                "before-upload": _vm.beforeUpload,
                                accept: "image/png,image/jpeg,image/jpg",
                              },
                            },
                            [
                              _vm.pram.backgroundImage
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: { src: _vm.pram.backgroundImage },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.pram.backgroundImage
                            ? _c("i", {
                                staticClass: "el-icon-delete remove-icon",
                                on: { click: _vm.removeImg },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v("支持上传png/jpg的图片格式，上传大小≤100KB"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "状态：",
                    prop: "status",
                    rules: _vm.statusRules,
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "status", $$v)
                        },
                        expression: "pram.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("禁用")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v("启用后该配置在移动端生效，否则不生效"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.closeEdit } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }